export enum ELiveDataMetrics {
  BID_WON = 3,

  IMPRESSIONS = 2,
  CPM = 5,

  ENDPOINT_REQUEST = 1,
  ENDPOINT_RESPONSE = 10,
  ENDPOINT_LATENCY = 6,

  AUCTION_INIT = 4,
  AUCTION_END = 11,
  AUCTION_LATENCY = 7,

  BID_RESPONSE = 9,
  BID_REQUEST = 12,
  BIDDER_LATENCY = 8,

  // Bid Errors Ev
  BID_ERROR = 13,
  BID_TIMEOUT = 14,

  // Campaign
  ADSERVER_REQUEST = 15,
  ADSERVER_FILLED = 16,
  ADSERVER_IMPRESSION = 17,
  ADSERVER_COMPLETE = 18,
  ADSERVER_QUARTILE1 = 19,
  ADSERVER_QUARTILE2 = 20,
  ADSERVER_QUARTILE3 = 21,
  ADSERVER_INVENTORY_REQUEST = 39,
  CAMPAIGN_PACING = 74,

  // SSAI
  // - stream base
  STREAM_START = 22,
  STREAM_RESPONSE = 23,
  STREAM_LATENCY = 24,
  STREAM_ERROR = 25,
  // ad
  STREAM_AD_IMPRESSION = 26,
  STREAM_AD_FILLED = 27,
  STREAM_AD_FILLED_LATENCY = 28,
  STREAM_AD_COMPLETE = 29,
  STREAM_AD_FETCH_TIMEOUT = 30,
  // pod
  STREAM_POD_REQUEST = 31,
  STREAM_POD_FILLED = 32,
  STREAM_POD_COMPLETE = 33,
  // chunklist
  STREAM_CHUNKLIST_TIMEOUT = 34,
  STREAM_CHUNKLIST_RESPONSE_LATENCY = 35,
  STREAM_CHUNKLIST_RESPONSE = 38,
  STREAM_CHUNKLIST_FETCH = 65,
  // playlist
  STREAM_PLAYLIST_TIMEOUT = 36,
  STREAM_TRANSCODE_MISS = 37,
  // metrics not saved because combination of multiple metrics
  METRICS_IDENTIFIER_REVENUE = 46,
  METRICS_IDENTIFIER_BID_ERROR_RATE = 62,
  METRICS_IDENTIFIER_FILL_RATE = 63,
  METRICS_IDENTIFIER_CUSTOM_METRIC = 64,
  METRICS_IDENTIFIER_PUBLICA_VAULT_LIFT = 80,
  UNKNOWN = 0,
}

// rate metrics for isRateMetric check
export enum ELiveDataTargetedRateMetrics {
  BID_ERROR_RATE = 62,
  FILL_RATE = 63,
  CAMPAIGN_PACING = 74,
}

export enum ELiveDataTargetedAvgMetrics {
  CPM = 5,
  ENDPOINT_LATENCY = 6,
  AUCTION_LATENCY = 7,
  BIDDER_LATENCY = 8,

  STREAM_LATENCY = 24,
  STREAM_AD_FILLED_LATENCY = 28,
  STREAM_CHUNKLIST_RESPONSE_LATENCY = 35,
}

// reverse mapping
export type ELiveDataMetricsKeyType = keyof typeof ELiveDataMetrics;

export const ELiveDataMetricsKey = new Map<ELiveDataMetrics, ELiveDataMetricsKeyType>(
  Object.entries(ELiveDataMetrics).map(
    ([key, value]: [ELiveDataMetricsKeyType, ELiveDataMetrics]) => [value, key],
  ),
);

const ELiveDataMetricsToString = {
  BID_WON: 'Bid Won',

  IMPRESSIONS: 'Impressions',
  CPM: 'CPM',

  ENDPOINT_REQUEST: 'Endpoint Request',
  ENDPOINT_RESPONSE: 'Endpoint Response',
  ENDPOINT_LATENCY: 'Endpoint Latency',

  AUCTION_INIT: 'Auction Init',
  AUCTION_END: 'Auction End',
  AUCTION_LATENCY: 'Auction Latency',

  BID_RESPONSE: 'Bid Response',
  BID_REQUEST: 'Bid Request',
  BIDDER_LATENCY: 'Bidder Latency',

  // Bid Errors Ev
  BID_ERROR: 'Bid Error',
  BID_TIMEOUT: 'Bid Timeout',
  BID_ERROR_RATE: 'Bid Error Rate',
  FILL_RATE: 'Fill Rate',

  // Campaign
  ADSERVER_REQUEST: 'Adserver Paced Request',
  ADSERVER_FILLED: 'Adserver Filled',
  ADSERVER_IMPRESSION: 'Adserver Impression',
  ADSERVER_COMPLETE: 'Adserver Complete',
  ADSERVER_QUARTILE1: 'Adserver Quartile 1',
  ADSERVER_QUARTILE2: 'Adserver Quartile 2',
  ADSERVER_QUARTILE3: 'Adserver Quartile 3',
  ADSERVER_INVENTORY_REQUEST: 'Adserver Raw Requests',
  CAMPAIGN_PACING: 'Campaign Pacing',

  // SSAI
  // - stream base
  STREAM_START: 'Stream Start',
  STREAM_RESPONSE: 'Stream Response',
  STREAM_LATENCY: 'Stream Latency',
  STREAM_ERROR: 'Stream Error',
  // ad
  STREAM_AD_IMPRESSION: 'Stream Ad Impression',
  STREAM_AD_FILLED: 'Stream Ad Filled',
  STREAM_AD_FILLED_LATENCY: 'Stream Ad Filled Latency',
  STREAM_AD_COMPLETE: 'Stream Ad Complete',
  STREAM_AD_FETCH_TIMEOUT: 'Stream Ad Fetch Timeout',
  // pod
  STREAM_POD_REQUEST: 'Stream Pod Request',
  STREAM_POD_FILLED: 'Stream Pod Filled',
  STREAM_POD_COMPLETE: 'Stream Pod Complete',
  // chunklist
  STREAM_CHUNKLIST_TIMEOUT: 'Stream Chunklist Timeout',
  STREAM_CHUNKLIST_RESPONSE_LATENCY: 'Stream Chunklist Response Latency',
  STREAM_CHUNKLIST_RESPONSE: 'Stream Chunklist Response',
  STREAM_CHUNKLIST_FETCH: 'Stream Chunklist Fetch',
  // playlist
  STREAM_PLAYLIST_TIMEOUT: 'Stream Playlist Timeout',
  STREAM_TRANSCODE_MISS: 'Stream Transcode Miss',
  // metrics not saved because combination of multiple metrics
  METRICS_IDENTIFIER_REVENUE: 'Revenue',
  METRICS_IDENTIFIER_BID_ERROR_RATE: 'Bid Error Rate',
  METRICS_IDENTIFIER_FILL_RATE: 'Fill Rate',
  METRICS_IDENTIFIER_CUSTOM_METRIC: 'Custom Metric',
  METRICS_IDENTIFIER_PUBLICA_VAULT_LIFT: 'Publica Vault Lift',
};

export function ELiveDataMetricsString(metric: ELiveDataMetrics): string {
  // @ts-ignore
  return ELiveDataMetricsToString[metric];
}
